var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Screen',_vm._b({},'Screen',{ ..._vm.$attrs, ..._vm.$props },false),[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.$t('screens.ConnectInteractiveScreen.description'))+" ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }